import Vue from 'vue'
import Router from 'vue-router'
import Base from './components/Base.vue'
import PruebaList from './components/PruebaList.vue'
import PruebaDetail from './components/PruebaDetail.vue'
import EscenarioDetail from './components/EscenarioDetail.vue'
import EnsayoList from './components/EnsayoList.vue'
import Summary from './components/Summary.vue'
import TestData from './components/TestData.vue'
import Viewer from './components/Viewer.vue'
import EnsayoDetail from './components/EnsayoDetail.vue'
import Ensayo from './components/Ensayo.vue'
import Main from './components/Main.vue'
import Images from './components/Images.vue'
import Login from './components/Login.vue'
import Admin from './components/Admin.vue'

import store from "./store";

Vue.use(Router)

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: Base,
            meta: {
                requiresAuth: true
            },
            children: [
				{ 
					path: '/', 
					component: PruebaList, 
				},
                { 
                    path: '/pruebas',
                    name: 'pruebas',
                    component: PruebaList
                },
                { 
                    path: '/imagenes', 
                    component: Images
                },
                { 
                    path: '/admin',
                    name: 'admin', 
                    component: Admin
                },
                { 
                    path: '/prueba/:id', 
                    component: PruebaDetail,
                    children: [
                        { 
                            path: '/', 
                            component: Summary 
                        },
                        { 
                            path: '/resumen', 
                            component: Summary 
                        },
                        { 
                            path: '/escenario', 
                            component: EscenarioDetail 
                        },
                        { 
                            path: '/ensayos', 
                            component: Ensayo,
                            children: [
                                { 
                                    path: '/', 
                                    component: EnsayoList 
                                },
                                { 
                                    path: '/lista', 
                                    component: EnsayoList 
                                },
                                { 
                                    path: '/detalle/:id', 
                                    component: EnsayoDetail 
                                },
                            ]
                        },
                        { 
                            path: '/datos', 
                            component: TestData
                        },
                    ]
                },
                {
                    path: '/viewer/:id',
                    component: Viewer
                },
			]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/main',
            name: 'main',
            component: Main
        },
    ]
})

router.beforeEach((to, from, next) => {

    store.dispatch('inspectToken');

    if (to.name !== 'login' && !store.state.isAuthenticated) next({ name: 'login' });
    else {
        if (to.name === 'admin' && !store.state.user.groups.includes(1)) next({ name: 'pruebas' });
        next();
    }

})

export default router